import { createRouter, createWebHistory } from 'vue-router'
import UploadImage from '@/components/UploadImage.vue'

const routes = [
  {
    path: '/',
    name: 'Upload Image',
    component: UploadImage
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
